import { useContext, useEffect, useState } from 'react';
import { getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import AudioIcon from '../../../../WorkspaceAssets/ListIcons/visualised-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';

import './AudioField.scss';

import WaveSurfer from 'wavesurfer.js';
import { IconJsxer } from '../../../../../../../helpers/IconHelper';

/*const waveImagesCache = {};
const clearOutOldWaveImagesFromCache = (featureId) => {
    console.log("[audioField] Clearing out old wave images from cache for feature ID:", featureId);
    Object.keys(waveImagesCache).forEach(key => {
        if (!key.startsWith(`wf_${featureId}-`)) {
            delete waveImagesCache[key];
        }
    });
    console.log("[audioField] Wave images cache after cleanup:", waveImagesCache);
};*/

const AudioField = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const [audioFileData, setAudioFileData] = useState(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    useEffect(() => {
        setAudioFileData(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);

    const fileChangeClickHandler = () => {
        props.openTemporaryAudioUploadPopup(
            audioFileData,
            (groupConfig?.parent?.name ? groupConfig?.parent?.name + ' > ' : '') + (groupConfig?.name ? groupConfig?.name + ' > ' : '') + moduleConfig.name,
            'This is a temporary audio uploader and is not final.',
        )
    }

    /* const [imageDimensions, setImageDimensions] = useState({width: 'unknown', height: 'unknown'});
    useEffect(() => {
        setImageDimensions({width: 'unknown', height: 'unknown'});
        if (imageFileData?.srcUrl) {
            const img = new Image();
            img.onload = () => {
                setImageDimensions({width: img.width, height: img.height});
            }
            img.src = imageFileData.srcUrl;
        }
    }, [imageFileData, imageFileData?.srcUrl]); */

    const waveformId = 'wf_' + props.selectedFeatureNode.id + fieldData?.customFieldConfig?.dataLink?.replace(/\./g, '_') + `_waveform_preview_${props.index ?? 0}_${props.visualisationComponentKey ?? 'default'}`;
    /* useEffect(() => {
        clearOutOldWaveImagesFromCache(props.selectedFeatureNode.id);
    }, [props.selectedFeatureNode.id]); */

    const [wavesurferInstance, setWavesurferInstance] = useState(null);
    useEffect(() => {
        if (audioFileData && audioFileData.srcUrl) {
            // if (!waveImagesCache[waveformId]) {
                // console.log('[timeline, useEffect] Creating waveform for', waveformId, 'with URL', audioFileData.srcUrl);
                const waveSurfer = WaveSurfer.create({
                    container: `#${waveformId}`,
                    waveColor: '#BCA4FF',
                    progressColor: '#9146FF',
                    url: audioFileData.srcUrl,
                    height: 50,
                    // responsive: true,
                    normalize: true,
                    hideScrollbar: true,
                    // barWidth: 2,
                });
                /* waveSurfer.on('ready', () => {
                    waveSurfer.exportImage().then((dataUrl) => {
                        // console.log('[timeline, useEffect] Waveform image data URL:', dataUrl);
                        waveImagesCache[waveformId] = dataUrl[0];
                        // console.log('[timeline, useEffect] Cached waveform image for', generatedWaveformContainerId, waveImagesCache);
                    });
                }); */
                setWavesurferInstance(waveSurfer);
                return () => {
                    // console.log('[timeline, useEffect] Destroying waveform for', generatedWaveformContainerId);
                    waveSurfer.destroy();
                    setWavesurferInstance(null);
                }
            // }
        }
    }, [audioFileData.srcUrl, waveformId]);

    const [isPlaying, setIsPlaying] = useState(false);
    useEffect(() => {
        if (wavesurferInstance) {
            const playHandler = () => { setIsPlaying(true); };
            const stopHandler = () => { setIsPlaying(false); };
            wavesurferInstance.on('play', playHandler);
            wavesurferInstance.on('finish', stopHandler);
            wavesurferInstance.on('pause', stopHandler);
        }
        return () => {
            if (wavesurferInstance) {
                wavesurferInstance.un('play');
                wavesurferInstance.un('finish');
                wavesurferInstance.un('pause');
            }
            setIsPlaying(false);
        };
    }, [wavesurferInstance]);

    return (
        <>
            <div className='v2-module-field-label'>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Audio File'}</div>
            <ModuleTextInput
                fieldLabel={<div className="v2-module-block-field-input-label" style={{backgroundColor: '#FFFFFF', backgroundImage: `url(${AudioIcon})`, backgroundSize: '1.8rem', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'}} />}
                value={typeof audioFileData === 'string' ? audioFileData : audioFileData?.originalFile ?? '<No Audio>'}
                fieldId={'audio-file'}
                enabled={props.isEnabled}
                editable={false}
                onChange={null}
                onClick={
                    props.isEnabled ? fileChangeClickHandler : null
                }
            />
            <div className='fl-row compact'>
                <div className={`play-button${wavesurferInstance ? ' btn-off' : ''}`} onClick={wavesurferInstance ? () => {wavesurferInstance.isPlaying() ? wavesurferInstance.stop() : wavesurferInstance.play()} : null}>
                    {IconJsxer.GetIcon(isPlaying ? IconJsxer.ICONS.stop : IconJsxer.ICONS.play, IconJsxer.ICON_STYLES.roundFormControl)}
                </div>
                <div id={`${waveformId}`} className={`audio-waveform-preview-holder${!props.isEnabled ? ' v2-module-disabled-field' : ''}`} onClick={props.isEnabled ? fileChangeClickHandler : null}>
                    {/* Waveform preview will be rendered here */}
                    {/*waveImagesCache[waveformId] &&
                        <img src={waveImagesCache[waveformId]} alt="Audio Waveform Preview" />
                    */}
                </div>
            </div>
            {/*imageFileData?.srcUrl &&
                <div className={`image-preview-holder${!props.isEnabled ? ' v2-module-disabled-field' : ''}`} onClick={props.isEnabled ? clickHandler : null}>
                    <img src={imageFileData?.srcUrl} alt={imageFileData?.originalFile} />
                    {imageDimensions.width !== 'unknown' &&
                        <div className="image-dimensions-label">{imageDimensions.width} x {imageDimensions.height}</div>
                    }
                    {imageDimensions.width === 'unknown' &&
                        <div className="image-dimensions-label">&nbsp;</div>
                    }
                </div>
            */}
        </>
    );
};

export default AudioField;
